export default __webpack_public_path__ + "static/media/channel-video.f3870742.png";